import { TicketMutationEvent } from "@jugl-web/domain-resources/tickets/types/TicketMutationEvent";
import { CRMChannel, WhatsappMessageModel } from "@jugl-web/rest-api";
import { InstagramMessageModel } from "@jugl-web/rest-api/integrations/models/InstagramMessage/InstagramMessageModel";
import { TwilioMessageModel } from "@jugl-web/rest-api/integrations/models/TwilioMessage";
import { WebChatBotMessageModel } from "@jugl-web/rest-api/integrations/models/WebChatBotMessage";
import { createContext } from "react";
import { Subject } from "rxjs";
import { EmailMessageModel } from "@jugl-web/rest-api/integrations/models/EmailMessage";
import { ConversationSidePanelTab } from "../../components/ConversationSidePanel/types";
import {
  ChannelListItem,
  ClientSupportView,
  ConversationModel,
  CreateTicketSidebarState,
  TicketDetailsSidebarState,
  TicketDetailsTabId,
} from "../../types";

export type ClientSupportPageContextValue = {
  refetchTrigger$: Subject<void>;
  ticketMutations$: Subject<TicketMutationEvent>;
  selectedView: ClientSupportView;
  selectView: (view: ClientSupportView) => void;
  selectedConversation?: ConversationModel;
  selectConversation: (
    conversation?: ConversationModel,
    auto?: boolean
  ) => void;
  selectedChannel: CRMChannel;
  selectChannel: (selectedChannel: CRMChannel) => void;
  ticketDetailsSidebarState: TicketDetailsSidebarState;
  openTicketDetailsSidebar: (
    ticketId: string,
    initialTabId?: TicketDetailsTabId
  ) => void;
  closeTicketDetailsSidebar: () => void;
  createTicketSidebarState: CreateTicketSidebarState;
  openCreateTicketSidebar: (
    initialFormValues?: CreateTicketSidebarState["initialFormValues"]
  ) => void;
  closeCreateTicketSidebar: () => void;
  replyMessage?:
    | WhatsappMessageModel
    | InstagramMessageModel
    | WebChatBotMessageModel
    | TwilioMessageModel
    | EmailMessageModel;
  setReplyMessage: (
    conversationId: string,
    message?:
      | WhatsappMessageModel
      | InstagramMessageModel
      | WebChatBotMessageModel
      | TwilioMessageModel
      | EmailMessageModel
  ) => void;
  incomingWhatsappMessages$: Subject<
    WhatsappMessageModel & { msg_status?: string }
  >;
  incomingInstagramMessages$: Subject<
    InstagramMessageModel & { msg_status?: string }
  >;
  incomingWebMessages$: Subject<
    WebChatBotMessageModel & { msg_status?: string }
  >;
  incomingTwilioMessages$: Subject<
    TwilioMessageModel & { msg_status?: string }
  >;
  incomingEmailMessages$: Subject<EmailMessageModel & { msg_status?: string }>;
  sendWebMessage: (params: {
    conv_id: string;
    conv_name: string;
    text: string;
  }) => void;
  isSendingMessage: boolean;
  openedUserProfile?: string;
  setIsSendingMessage: (isSending: boolean) => void;
  setOpenedUserProfile: (userId?: string) => void;
  availableChannels: ChannelListItem[];
  isConversationSidePanelOpen: boolean;
  conversationSidePanelVariant?: ConversationSidePanelTab;
  openConversationSidePanel: (params?: {
    variant?: ConversationSidePanelTab;
  }) => void;
  closeConversationSidePanel: () => void;
  isContactBlocked: boolean;
  isChatExpired: boolean;
  chatSecondsLeft: number;
};

export const ClientSupportContext =
  createContext<ClientSupportPageContextValue | null>(null);
